import Navbar from '@/components/feature/Navbar'
import Footer from '@/components/feature/Footer'
import SEOHead from '@/components/feature/SEOHead'
import Breadcrumb from '@/components/feature/Breadcrumb'

export default function AboutPage() {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于我们 - 韩漫画网',
    description: '韩漫画网致力于为广大漫画爱好者提供免费、高清、更新及时的韩国漫画在线阅读服务。',
    url: 'http://eocesp.cn/about',
    isPartOf: {
      '@type': 'WebSite',
      name: '韩漫画网',
      url: 'http://eocesp.cn/',
    },
    about: {
      '@type': 'Organization',
      name: '韩漫画网',
      description: '韩漫画网 - 免费在线观看韩国漫画平台',
      url: 'http://eocesp.cn/',
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer service',
        email: 'hello@eocesp.cn',
        availableLanguage: ['Chinese'],
      },
    },
  }

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '韩漫画网的漫画是免费观看的吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '是的，韩漫画网所有漫画资源均免费在线观看。我们致力于为漫画爱好者提供免费、高清的阅读体验。',
        },
      },
      {
        '@type': 'Question',
        name: '韩漫画网更新频率是怎样的？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '韩漫画网的漫画每日更新，各作品按照原作者的更新节奏同步上线。您可以订阅更新通知，第一时间获取最新章节推送。',
        },
      },
      {
        '@type': 'Question',
        name: '支持哪些设备阅读？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '韩漫画网支持网页版访问，适用于电脑、平板和手机等所有主流设备。我们针对不同屏幕尺寸进行了优化，确保您在任何设备上都能获得舒适的阅读体验。',
        },
      },
      {
        '@type': 'Question',
        name: '如何反馈漫画问题或提出建议？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以通过邮箱 hello@eocesp.cn 与我们联系，反馈任何漫画相关问题或提出宝贵建议。我们非常重视每一位用户的意见。',
        },
      },
    ],
  }

  return (
    <>
      <SEOHead
        title="关于我们 - 韩漫画网 - 免费在线观看韩国漫画平台"
        description="韩漫画网致力于为广大漫画爱好者提供免费、高清、更新及时的韩国漫画在线阅读服务。了解我们的品牌故事、核心优势与联系方式。"
        keywords="关于韩漫画网,韩漫画网品牌介绍,韩漫画网联系方式,免费漫画平台"
        canonicalUrl="http://eocesp.cn/about"
        schema={{ ...schema, ...faqSchema }}
      />
      <Navbar />

      <main className="pt-16">
        <section className="relative w-full h-[350px] md:h-[450px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Artistic%20Korean%20manhwa%20style%20illustration%2C%20warm%20cozy%20reading%20atmosphere%2C%20bookshelves%20filled%20with%20colorful%20manga%20volumes%2C%20soft%20natural%20light%20streaming%20through%20window%2C%20warm%20cream%20and%20golden%20tones%2C%20clean%20simple%20composition%2C%20gentle%20gradient%20background%2C%20inviting%20and%20peaceful%20mood&width=1800&height=700&seq=about-hero-manhwa-v2&orientation=landscape"
            alt="关于韩漫画网"
            title="韩漫画网 - 关于我们"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
          <div className="absolute inset-0 flex items-center">
            <div className="px-4 md:px-6 w-full max-w-[1400px] mx-auto">
              <div className="max-w-2xl">
                <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-background-50 leading-tight">
                  关于<br />韩漫画网
                </h1>
                <p className="mt-4 text-sm md:text-base text-background-200/90 max-w-lg leading-relaxed">
                  为漫画爱好者而生，打造国内领先的免费韩漫阅读平台
                </p>
              </div>
            </div>
          </div>
        </section>

        <div className="px-4 md:px-6 max-w-[1400px] mx-auto py-6">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: '关于我们' },
            ]}
          />
        </div>

        <section className="py-10 md:py-16 bg-background-50">
          <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
            <div className="max-w-3xl mx-auto text-center mb-12 md:mb-16">
              <p className="text-xs uppercase tracking-widest text-foreground-500 font-medium mb-3">品牌故事</p>
              <h2 className="text-2xl md:text-4xl font-heading text-foreground-900 mb-4">
                用心打造最好的韩漫平台
              </h2>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                韩漫画网成立于2024年，由一群热爱漫画的二次元爱好者共同创办。我们发现国内缺少一个专注于韩国漫画的优质阅读平台——要么资源不全，要么更新太慢，要么广告太多影响阅读体验。于是，韩漫画网应运而生。
              </p>
              <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
                从最初只有几十部作品的小站点，到如今汇聚<strong className="text-primary-500">数千部优质韩漫</strong>的综合平台，我们始终坚守初心：让每一位漫画爱好者都能在这里<strong className="text-primary-500">免费、高清、无广告干扰</strong>地享受阅读的乐趣。每一部作品的引入都经过精心筛选，确保内容质量与更新速度。
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
              {[
                { title: '海量资源 🎯', desc: '覆盖恋爱、奇幻、动作、悬疑等八大分类，50000+部精选韩漫作品持续扩充中', bg: 'bg-background-100' },
                { title: '免费高清 📺', desc: '所有漫画完全免费阅读，高清画质还原每一个细节，无广告无弹窗纯净体验', bg: 'bg-background-100' },
                { title: '每日更新 ⚡', desc: '紧跟原作更新节奏，每日同步上线最新章节。支持更新推送通知，追番不等待', bg: 'bg-background-100' },
                { title: '多端适配 📱', desc: '电脑、平板、手机全设备适配，随时随地享受流畅阅读体验', bg: 'bg-background-100' },
              ].map((item) => (
                <div key={item.title} className={`${item.bg} rounded-lg p-6`}>
                  <h3 className="text-base font-heading text-foreground-900 mb-3">{item.title}</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-10 md:py-16 bg-background-100">
          <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
            <div className="text-center mb-12">
              <p className="text-xs uppercase tracking-widest text-foreground-500 font-medium mb-3">联系我们</p>
              <h2 className="text-2xl md:text-4xl font-heading text-foreground-900 mb-4">
                期待你的声音 💬
              </h2>
              <p className="text-sm text-foreground-600 max-w-md mx-auto">
                无论是对平台的建议、合作意向还是问题反馈，我们都非常乐意倾听
              </p>
            </div>

            <div className="max-w-3xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="bg-background-50 rounded-lg p-6 text-center">
                <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-primary-100 flex items-center justify-center">
                  <i className="ri-mail-line text-primary-500 text-xl"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-2">电子邮箱</h3>
                <p className="text-xs text-foreground-600">hello@eocesp.cn</p>
                <p className="text-xs text-foreground-500 mt-1">工作日 24 小时内回复</p>
              </div>
              <div className="bg-background-50 rounded-lg p-6 text-center">
                <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-briefcase-line text-accent-500 text-xl"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-2">商务合作</h3>
                <p className="text-xs text-foreground-600">hello@eocesp.cn</p>
                <p className="text-xs text-foreground-500 mt-1">请注明合作意向</p>
              </div>
              <div className="bg-background-50 rounded-lg p-6 text-center">
                <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-secondary-100 flex items-center justify-center">
                  <i className="ri-time-line text-secondary-500 text-xl"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-2">工作时间</h3>
                <p className="text-xs text-foreground-600">周一至周五</p>
                <p className="text-xs text-foreground-500 mt-1">9:00 - 18:00</p>
              </div>
            </div>
          </div>
        </section>

        <section className="py-10 md:py-16 bg-background-50">
          <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
            <div className="max-w-3xl mx-auto">
              <div className="text-center mb-10">
                <p className="text-xs uppercase tracking-widest text-foreground-500 font-medium mb-3">常见问题</p>
                <h2 className="text-2xl md:text-4xl font-heading text-foreground-900 mb-4">
                  你可能想知道 🤔
                </h2>
              </div>
              <div className="space-y-3">
                {[
                  { q: '韩漫画网的漫画是免费观看的吗？', a: '是的，韩漫画网所有漫画资源均免费在线观看。我们致力于为漫画爱好者提供免费、高清的阅读体验，无任何隐藏收费。' },
                  { q: '韩漫画网更新频率是怎样的？', a: '韩漫画网的漫画每日更新，各作品按照原作者的更新节奏同步上线。您可以订阅更新通知，第一时间获取最新章节推送。' },
                  { q: '支持哪些设备阅读？', a: '韩漫画网支持网页版访问，适用于电脑、平板和手机等所有主流设备。我们针对不同屏幕尺寸进行了优化，确保您在任何设备上都能获得舒适的阅读体验。' },
                  { q: '如何反馈漫画问题或提出建议？', a: '您可以通过邮箱 hello@eocesp.cn 与我们联系，反馈任何漫画相关问题或提出宝贵建议。我们非常重视每一位用户的意见。' },
                  { q: '可以在韩漫画网投稿自己的漫画作品吗？', a: '目前我们正在规划创作者入驻计划，欢迎通过 hello@eocesp.cn 与我们沟通合作事宜，我们非常期待与更多优秀的漫画创作者合作。' },
                ].map((item, index) => (
                  <details key={index} className="bg-background-100 rounded-lg group">
                    <summary className="px-5 py-4 cursor-pointer flex items-center justify-between text-sm font-medium text-foreground-900 list-none">
                      {item.q}
                      <i className="ri-arrow-down-s-line text-foreground-500 group-open:rotate-180 transition-transform"></i>
                    </summary>
                    <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                      {item.a}
                    </div>
                  </details>
                ))}
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  )
}